import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'CM No',
     label: 'CM No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'referenceNumber',
     field: FIELDS.REFERENCE_NUMBER,
     title: 'Reference',
     label: 'Reference',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'paymentDate',
     field: FIELDS.PAYMENT_DATE,
     title: 'Payment Date',
     label: 'Payment Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'paymentMethodName',
     field: FIELDS.PAYMENT_METHOD_NAME,
     title: 'Payment Method',
     label: 'Payment Method',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'amount',
     field: FIELDS.AMOUNT,
     title: 'Amount',
     label: 'Amount',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'applied',
     field: FIELDS.APPLIED,
     title: 'Applied',
     label: 'Applied',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'balance',
     field: FIELDS.BALANCE,
     title: 'Balance',
     label: 'Balance',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isPending',
     field: FIELDS.IS_PENDING,
     title: 'Pending',
     label: 'Pending',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isRefund',
     field: FIELDS.IS_REFUND,
     title: 'Refund',
     label: 'Refund',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isClosedRefund',
     field: FIELDS.IS_CLOSED_REFUND,
     title: 'Closed Refund',
     label: 'Closed Refund',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'refundFromAccount',
     field: FIELDS.REFUND_FROM_ACCOUNT,
     title: 'Refund Account',
     label: 'Refund Account',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'comment',
     field: FIELDS.COMMENT,
     title: 'Comment',
     label: 'Comment',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesOrderId',
     field: FIELDS.SALES_ORDER_ID,
     title: 'SO No',
     label: 'SO No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'soDate',
     field: FIELDS.SODATE,
     title: 'SO Date',
     label: 'SO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'purchaseOrderId',
     field: FIELDS.PURCHASE_ORDER_ID,
     title: 'PO No',
     label: 'PO No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'poDate',
     field: FIELDS.PODATE,
     title: 'PO Date',
     label: 'PO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
